/*
  File Pulled From the Accelerator

  Gets form to:
   watch for submit 
   prevent default
   process js add to cart request
   potentially hide or show an error message
   update cart bubble quantity
  Gets button to:
   disable while processing js on form submission
*/

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      //get form
      this.form = this.querySelector('form');

      //get quantity
      this.quantity = this.querySelector(".main-product__info__buy-buttons__quantity");
      this.quantityButtons = this.quantity?.querySelectorAll('[data-adjust]');
      this.quantityInput = this.quantity?.querySelector('input[name="quantity"]');

      //get submit buttons
      this.submitButton = this.querySelector('[type="submit"]');
    
      this.init();
    }

    init() {

      //Pulled this from accelerator, I have no idea why they disable this to begin with. Without undisabling it, the form doesn't have a product id to submit
      const variantIdInput = this.form?.querySelector('[name=id]')
      variantIdInput && (variantIdInput.disabled = false)

      // Form submit listener
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));

      if (this.quantity && this.quantityInput && this.quantityButtons){

        // Quantity +/- buttons
        this.quantityButtons.forEach(button => {
          button.addEventListener('click', (event) => {
            const amount = parseInt(event.currentTarget.dataset.adjust, 10);
            this.adjustQuantity(amount);
          });
        });
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Passing no argument will hide the error message if one was on screen because errorText defaults to false
      this.handleErrorMessage();

      // Disabling the button temporarily so that the request can be processed
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        }
      };

      const formData = new FormData(this.form);
      formData.set('quantity', this.quantityInput?.value || '1');
      
      //This is how we'd update the cart bubble if we implemented it using the accelerator's html, but we use an apps smartcart and they handle the update for us
    //  formData.append('sections', ['cart-bubble']);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            this.error = true;

            return;
          }

          //This is how we'd update the cart bubble if we implemented it using the accelerator's html, but we use an app's smartcart and they handle the update for us
          // document.getElementById('CartBubble').innerHTML = `(${response.sections['cart-bubble'].match(/\d+/)})`;

          this.error = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally((response) => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorText = false) {
      this.errorMessage = this.errorMessage || this.querySelector('.message-error');
      if (!this.errorMessage) return;

      this.errorMessage.classList.toggle('hidden', !errorText);

      this.errorMessage.textContent = errorText ? errorText : '';

    }

    adjustQuantity(amount) {
      let currentValue = parseInt(this.quantityInput.value, 10) || 1;
      let min = parseInt(this.quantityInput.min || "1", 10);
      let newValue = currentValue + amount;
    
      if (newValue < min) newValue = min;
  
      //get all quantities on page cause there's multiple after we clone for sticky bar
      document.querySelectorAll('product-form input[name="quantity"]').forEach((input) => {
        input.value = newValue;
      }) 
    }

    createStickyBar(form){
      const original = (form.dataset.buffByYou !== undefined && form.dataset.buffByYou === "false") ? form : null;
      if (!original) return;
      console.log("create sticky bar");

      // Clone the product-form
      const clone = original.cloneNode(true);
      this.prepareStickyClone(clone);
      const productInfo = clone.querySelector("template").content;

      // Create wrapper div and add classes
      const wrapper = document.createElement('div');
      wrapper.classList.add('buff-section-2025', '__color-scheme-primary', "main-product__sticky-bar");

      // Append the clone to the wrapper
      wrapper.appendChild(productInfo);
      wrapper.appendChild(clone);

      // Append the wrapper to the body
      document.body.appendChild(wrapper);

      let viewportTallEnough = original.getBoundingClientRect().top < window.innerHeight;

      if (!viewportTallEnough) {
        wrapper.classList.add("__initiated");
      } else {

        window.addEventListener('scroll', () => {

          if (original.getBoundingClientRect().bottom < 150 || original.getBoundingClientRect() > window.innerHeight ) {
            //The element is offscreen
            if (!wrapper.classList.contains("__initiated")) {
              wrapper.classList.add("__initiated");
            }
          } else {
            //The element is visible
            if (wrapper.classList.contains("__initiated")) {
              wrapper.classList.remove("__initiated");
            }
          }
        });
      }
    }

    prepareStickyClone(clone) {
      const clonedForm = clone.querySelector('form');
      const clonedQuantityInput = clone.querySelector('input[name="quantity"]');
      if (!clonedForm) return;

      const originalFormId = clonedForm.id;
      const stickyFormId = `${originalFormId}-Sticky`;

      clone.dataset.stickyProductForm = "true";
      clonedForm.id = stickyFormId;

      if (clonedQuantityInput) {
        const originalQuantityId = clonedQuantityInput.id;
        clonedQuantityInput.id = `${originalQuantityId}-Sticky`;
        clonedQuantityInput.setAttribute("form", stickyFormId);

        clone.querySelectorAll(`[for="${originalQuantityId}"]`).forEach((label) => {
          label.setAttribute("for", clonedQuantityInput.id);
        });
      }
    }

    removeStickyBar() {
      const bars = document.querySelectorAll(".main-product__sticky-bar");
      bars.forEach((bar) => {
        bar.remove();
      })
    }
  });
}

//clone the product form to create a sticky add to cart bar
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('product-form[data-buff-by-you="false"]');
  form?.createStickyBar(form);
});
